import { render, staticRenderFns } from "./OverlayMenu.vue?vue&type=template&id=bc61ccf2&scoped=true&"
import script from "./OverlayMenu.vue?vue&type=script&lang=js&"
export * from "./OverlayMenu.vue?vue&type=script&lang=js&"
import style0 from "./OverlayMenu.vue?vue&type=style&index=0&id=bc61ccf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc61ccf2",
  null
  
)

export default component.exports